<section class="page">
  <header class="page-header">
    <h2>Couples d'amorces</h2>
    <p class="subtitle">Créer, modifier et voir/supprimer les couples d'amorces utilisés dans les analyses.</p>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (showCreateSection) {
    <div class="forms-grid">
      <form class="panel" (ngSubmit)="createAmorce()">
        <h3>Créer un couple d'amorces</h3>

        <label for="nouveau-code">Code</label>
        <input id="nouveau-code" name="nouveauCode" [(ngModel)]="nouveauCode" maxlength="5" required />

        <label for="nouveau-nom-officiel">Nom officiel</label>
        <input id="nouveau-nom-officiel" name="nouveauNomOfficiel" [(ngModel)]="nouveauNomOfficiel" maxlength="255" />

        <label for="nouvelle-cible">Cible</label>
        <select id="nouvelle-cible" name="nouvelleCibleId" [(ngModel)]="nouvelleCibleId" [disabled]="loadingCibles">
          <option value="">-- aucune --</option>
          @for (cible of cibles; track cible.id) {
            <option [value]="cible.id">{{ cible.nom }}</option>
          }
        </select>

        <label for="nouvelle-longueur">Longueur en paires de bases</label>
        <input id="nouvelle-longueur" name="nouvelleLongueur" [(ngModel)]="nouvelleLongueur" type="number" min="0" step="1" />

        <label for="nouveau-forward">Forward</label>
        <textarea id="nouveau-forward" name="nouveauForward" [(ngModel)]="nouveauForward" rows="3"></textarea>

        <label for="nouveau-reverse">Reverse</label>
        <textarea id="nouveau-reverse" name="nouveauReverse" [(ngModel)]="nouveauReverse" rows="3"></textarea>

        <button type="submit" [disabled]="loading">Créer</button>
      </form>
    </div>
  }

  @if (showEditSection) {
    <div class="forms-grid">
      <form class="panel" (ngSubmit)="updateAmorce()">
        <h3>Éditer un couple d'amorces</h3>

        <label for="select-amorce">Couple d'amorces</label>
        <select id="select-amorce" name="selectedId" [(ngModel)]="selectedId" (ngModelChange)="onSelectChange()">
          <option value="">-- sélectionner --</option>
          @for (amorce of amorces; track amorce.id) {
            <option [value]="amorce.id">{{ amorce.code }} - {{ amorce.nom_officiel || 'Sans nom' }}</option>
          }
        </select>

        <label for="code-edition">Code</label>
        <input id="code-edition" name="codeEdition" [(ngModel)]="codeEdition" maxlength="5" required />

        <label for="nom-officiel-edition">Nom officiel</label>
        <input id="nom-officiel-edition" name="nomOfficielEdition" [(ngModel)]="nomOfficielEdition" maxlength="255" />

        <label for="cible-edition">Cible</label>
        <select id="cible-edition" name="cibleIdEdition" [(ngModel)]="cibleIdEdition" [disabled]="loadingCibles">
          <option value="">-- aucune --</option>
          @for (cible of cibles; track cible.id) {
            <option [value]="cible.id">{{ cible.nom }}</option>
          }
        </select>

        <label for="longueur-edition">Longueur en paires de bases</label>
        <input id="longueur-edition" name="longueurEdition" [(ngModel)]="longueurEdition" type="number" min="0" step="1" />

        <label for="forward-edition">Forward</label>
        <textarea id="forward-edition" name="forwardEdition" [(ngModel)]="forwardEdition" rows="3"></textarea>

        <label for="reverse-edition">Reverse</label>
        <textarea id="reverse-edition" name="reverseEdition" [(ngModel)]="reverseEdition" rows="3"></textarea>

        <button type="submit" [disabled]="loading">Enregistrer</button>
      </form>
    </div>
  }

  @if (showListSection) {
    <section class="panel">
      <h3>Liste des couples d'amorces</h3>
      @if (loadingList) {
        <p>Chargement des couples d'amorces...</p>
      } @else if (amorces.length === 0) {
        <p>Aucun couple d'amorces disponible.</p>
      } @else {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Code</th>
                <th>Nom officiel</th>
                <th>Cible</th>
                <th>Longueur en paires de bases</th>
                <th>Forward</th>
                <th>Reverse</th>
                @if (showDeleteActionsInTable) {
                  <th>Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (amorce of amorces; track amorce.id) {
                <tr>
                  <td>{{ amorce.id }}</td>
                  <td>{{ amorce.code }}</td>
                  <td>{{ amorce.nom_officiel || '-' }}</td>
                  <td>{{ amorce.cible_nom || '-' }}</td>
                  <td>{{ amorce.longueur ?? '-' }}</td>
                  <td>{{ amorce.forward || '-' }}</td>
                  <td>{{ amorce.reverse || '-' }}</td>
                  @if (showDeleteActionsInTable) {
                    <td class="actions-cell">
                      <button
                        type="button"
                        class="danger"
                        [disabled]="loading || deletingAmorceId === amorce.id"
                        (click)="deleteAmorceRow(amorce)"
                      >
                        {{ deletingAmorceId === amorce.id ? 'Suppression...' : 'Supprimer' }}
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }
</section>
